export default {"src":"/_next/static/media/rightLine.2d779fa6.svg","height":2,"width":91,"blurWidth":0,"blurHeight":0};